import React, {useEffect} from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import MainForgotPassword from '../../components/forgot-pass/MainForgotPassword';
import { useNavigate } from 'react-router-dom';
import { Card, Grid } from '@mui/material';
import Storage from '../../services/Storage';

export default function ForgotPassword() {

  const navigate = useNavigate();

  useEffect(() => {
    if (Storage.getLocalAccessToken() !== null) {
      navigate('/dashboard', { replace: true })
    }
  }, [navigate])
  return (
    <StyledEngineProvider injectFirst>
      <Card>
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item xs={12}>
          <MainForgotPassword />
        </Grid>
      </Grid>
    </Card>
    </StyledEngineProvider >
  );
}
